/**
 * 261030 S12f fix1 — 409 «hash đã đổi» ở ba cổng duyệt. Máy có thể cập nhật dữ liệu (đề xuất máy cho mục dò thiếu, chuẩn hoá hình thái…) giữa lúc người mở hộp và lúc bấm Duyệt ⇒ BE trả 409 kèm hash mới.
 * Quy tắc: KHÔNG bắt người tự F5 — tự tải lại status, cập nhật hộp bằng hash/dữ liệu mới, báo MỘT câu ngắn; bấm Duyệt tiếp là qua. Tách khỏi file import antd để test được dưới jest.
 */
export const HASH_CHANGED_CODES: readonly string[] = ['STEP1_HASH_MISMATCH', 'ASSETS_HASH_MISMATCH', 'BOARD_HASH_MISMATCH'];
export const HASH_CHANGED_TEXT = 'Dữ liệu vừa được máy cập nhật, kiểm lại rồi bấm Duyệt.';

/** Mã 409 «hash đã đổi» của cổng duyệt, hoặc null (lỗi khác / không phải 409). */
export function hashChangedCodeOf(err: any): string | null {
  const res = err?.response;
  if (res?.status !== 409) return null;
  const code = res?.data?.code ?? res?.data?.errorCode;
  return typeof code === 'string' && HASH_CHANGED_CODES.includes(code) ? code : null;
}
